export const componentsUploadEn = {
  error: {
    fileSizeExceeded: 'File size ({{actualSize}}MB) exceeds the maximum allowed size of {{maxSize}}MB.',
    uploadFailed: 'Failed to upload the file. Please try again.'
  }
};